module.exports = __webpack_public_path__ + "media/images/icons/twotone/like-3a744ef47d41063549170c966bccfbcb.svg";